import SignupBlock from './SignupBlock';
import { SignupBlockProps, SignupBlockValueProps } from './types';

export type { SignupBlockProps, SignupBlockValueProps };
export default SignupBlock;
